/**
 * RankForge Analytics & Variant Tracking
 * 
 * This script handles:
 * - Session management
 * - Variant impression tracking
 * - CTA click tracking
 * - Conversion tracking
 * - Metric ingestion to RankForge API
 * 
 * Usage: Include in theme.liquid header
 * <script src="{{ 'rankforge-tracker.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';
  
  // RankForge API endpoint
  const RANKFORGE_API = 'http://localhost:8001/api/metrics/ingest';
  
  // Session management
  function getSessionId() {
    let sessionId = sessionStorage.getItem('rf_session_id');
    if (!sessionId) {
      sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('rf_session_id', sessionId);
    }
    return sessionId;
  }
  
  // Track variant view (impression)
  function trackVariantView(data) {
    const payload = {
      ts: new Date().toISOString(),
      source: 'shopify',
      metrics: [{
        name: 'variant_view',
        value: 1,
        page: data.page || window.location.pathname,
        variant: data.variant_id,
        session_id: getSessionId()
      }]
    };
    
    sendToRankForge(payload);
    console.log('[RankForge] Variant view tracked:', data.variant_id);
  }
  
  // Track CTA click
  function trackCTAClick(variantId, zone) {
    const payload = {
      ts: new Date().toISOString(),
      source: 'shopify',
      metrics: [{
        name: 'cta_click',
        value: 1,
        page: window.location.pathname,
        variant: variantId,
        session_id: getSessionId()
      }]
    };
    
    sendToRankForge(payload);
    console.log('[RankForge] CTA click tracked:', variantId, zone);
  }
  
  // Track conversion (add to cart)
  function trackConversion(variantId, amount) {
    const payload = {
      ts: new Date().toISOString(),
      source: 'shopify',
      metrics: [{
        name: 'conversion',
        value: 1,
        page: window.location.pathname,
        variant: variantId,
        session_id: getSessionId()
      }, {
        name: 'aov',
        value: amount || 0,
        page: window.location.pathname,
        variant: variantId,
        session_id: getSessionId()
      }]
    };
    
    sendToRankForge(payload);
    console.log('[RankForge] Conversion tracked:', variantId, amount);
  }
  
  // Send data to RankForge API
  function sendToRankForge(payload) {
    // Use sendBeacon for reliability (works even if page is closing)
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon(RANKFORGE_API, blob);
    } else {
      // Fallback to fetch
      fetch(RANKFORGE_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(err => console.error('[RankForge] Tracking error:', err));
    }
  }
  
  // Track page view with variant
  function trackPageView() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('rf_variant');
    
    if (variantId) {
      const payload = {
        ts: new Date().toISOString(),
        source: 'shopify',
        metrics: [{
          name: 'page_view',
          value: 1,
          page: window.location.pathname,
          variant: variantId,
          session_id: getSessionId()
        }]
      };
      
      sendToRankForge(payload);
      console.log('[RankForge] Page view tracked with variant:', variantId);
    }
  }
  
  // Listen for add-to-cart events
  function setupCartTracking() {
    // Shopify cart add event
    document.addEventListener('submit', function(e) {
      const form = e.target;
      
      // Check if it's an add-to-cart form
      if (form.action && form.action.indexOf('/cart/add') > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('rf_variant');
        
        if (variantId) {
          // Get price from form
          const priceInput = form.querySelector('[name="price"]');
          const amount = priceInput ? parseFloat(priceInput.value) / 100 : 0;
          
          trackConversion(variantId, amount);
        }
      }
    });
  }
  
  // Initialize
  function init() {
    console.log('[RankForge] Tracker initialized');
    trackPageView();
    setupCartTracking();
  }
  
  // Public API
  window.rankforge = {
    trackVariantView,
    trackCTAClick,
    trackConversion,
    getSessionId,
    version: '1.0.0'
  };
  
  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
